module.exports = __webpack_public_path__ + "img/h.1ed68d48.jpg";